import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/NumberAndPlace/NumberAndPlaceLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";
import { Textfit } from 'react-textfit';

var image;

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}


//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


function GenQuestion(q) {
  var question;
  var image;
  var questionAnswers = [];
  var time = "";
  var questionHTML = "";
  var parameters = q.image_parameter.split(",");//split parameters
  console.log(q);
  //check image object to determine if subitising subject
  if (q.image != "a b c" && q.image != "Objects" && q.image != "abc") {
    question = q.question_line_1;
    if (q.time_on_screen != "") {
      console.log("SET TIME");
      time = q.time_on_screen.substring(0, q.time_on_screen.length - 1);
    }
    var answerNumber = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//generate answer
    //image = q.image + answerNumber + ".png";//image = imagename plus number such as "Emile2.png"
    image = q.image.toLowerCase() + answerNumber + ".png";
    var answers = [];
    answers.push(answerNumber);//add correct
    for (let i = 0; i < 3; i++) {//generate wrong
      var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]) + 2, answers)//wrong is random range plus 1
      answers.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      });
    }
    questionAnswers.push({
      correct: true,
      value: answerNumber
    });
  } else {
    //number bonds
    if (q.image == "a b c" || q.image == "abc") {
      console.log("number bonds");
      //set generated total number
      var total = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));
      question = q.question_line_1.replace("$", total);//set question line
      //generate number "a" = 1-total
      //number b = total - a
      //number c = random number that isnt a or b
      var a = GenerateRandom(1, total - 1);
      var b = total - a;
      var usedNumbers = [];
      usedNumbers.push(a);
      if (a != b) {
        usedNumbers.push(b);
      }
      console.log(total);
      console.log(usedNumbers);
      var c = GenerateUniqueRandom(1, total + 1, usedNumbers);
      //push right answer
      questionAnswers.push({
        correct: true,
        value: a + "," + b
      });
      questionAnswers.push({
        correct: false,
        value: b + "," + c
      });
      questionAnswers.push({
        correct: false,
        value: c + "," + a
      });
      //create html of numbers
      var numbers = []
      numbers.push(a, b, c);
      shuffleArray(numbers);
      questionHTML = "<div style='font-size:200px; text-shadow:3px 2px #000000;color:white'>" + numbers[0] + "  " + numbers[1] + "  " + numbers[2] + "</div>";
    }
    else {
      if (q.topic_key == "NSense8" || q.topic_key == "NSense9") {//addition & subtraction level 1
        var num1 = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//$
        var numused = [];
        numused.push(num1);
        var num2 = GenerateUniqueRandom(parseInt(parameters[4]), parseInt(parameters[5]), numused);//%
        if (q.topic_key == "NSense9") {
          num2 = GenerateUniqueRandom(parseInt(parameters[4]), num1, numused);//%
        }
        question = q.question_line_1.replace("$", num1);//replace $ with question_line_1
        question = question.replace("%", num2);
        var answer;
        if (question.includes("+")) {//addition answer
          answer = num1 + num2;
        } else {
          answer = num1 - num2;
        }
        var numbersUsed = []
        numbersUsed.push(answer);
        //wrong one = $, wrong two = %, wrong 3 = a - b or 0 if lower OR IF minus then add
        questionAnswers.push({
          correct: false,
          value: num1
        });
        if (num2 != answer) {
          questionAnswers.push({
            correct: false,
            value: num2
          });
        } else {
          questionAnswers.push({
            correct: false,
            value: GenerateUniqueRandom(1, 9, numbersUsed)
          });
        }
        var wrong3 = num1 - num2;
        if (question.includes("+")) {
          if (wrong3 < 0) {
            wrong3 = num2 - num1;
          }
          if (wrong3 < 0) {
            wrong3 = 0;
          }
        } else {
          wrong3 = num1 + num2;
        }

        questionAnswers.push({
          correct: false,
          value: wrong3
        });
        questionAnswers.push({
          correct: true,
          value: answer
        });


      } else {//add sub level 2
        var num1 = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//$
        var num2 = GenerateRandom(parseInt(parameters[4]), parseInt(parameters[5]));//%
        //sometimes it is % generated and sometimes it is ? generated, need to look into that
        if (q.topic_key == "NSense10") {
          question = q.question_line_1.replace("$", num1);
          answer = num2;
          question = question.replace("%", num1 + num2);
          var numbersUsed = []
          numbersUsed.push(answer);
          for (let i = 0; i < 3; i++) {
            var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]), numbersUsed)
            questionAnswers.push({
              correct: false,
              value: wrong
            });
            numbersUsed.push(wrong);
          }
          questionAnswers.push({
            correct: true,
            value: answer
          });

        } else if (q.topic_key == "NSense11") {
          console.log("help");
          console.log(num1);
          num2 = GenerateRandom(parseInt(parameters[4]), num1);
          console.log(num2);
          question = q.question_line_1.replace("$", num1);
          question = question.replace("%", num2);
          var answer = num1 - num2;
          var numbersUsed = []
          numbersUsed.push(answer);
          for (let i = 0; i < 3; i++) {
            var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]), numbersUsed)
            questionAnswers.push({
              correct: false,
              value: wrong
            });
            numbersUsed.push(wrong);
          }
          questionAnswers.push({
            correct: true,
            value: answer
          });
        }
      }
    }
  }

  shuffleArray(questionAnswers);

  let questionObj = {
    question: question,
    answers: questionAnswers,
    time: time,
    image: image,
    questionHTML: questionHTML,
    topic_id: q.topic_id
  };

  console.log(questionObj);
  return questionObj;
}


var hideImageStart = false;
var oldQuestion = undefined;

export default function Multiplayer({ ...props }) {
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([,]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      //correct answer
      if (value.correct == true) {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);
        if (multiplier != 0 && multiplier != undefined)
          props.SubmitScore(multiplier * 10);


        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
          props.SubmitScore(-10)
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var difficulty = Math.floor(Math.random() * questions.length);
    var questionNum = Math.floor(Math.random() * questions[difficulty].length)
    currQuestion = GenQuestion(questions[difficulty][questionNum]);;
    console.log(questions[difficulty][questionNum])
    console.log(currQuestion);
    setCurrentQuestion(currQuestion);
    NewImage();
    return currQuestion;
  }

  var hideImage = false;


  var DelayImage = function (delay) {
    console.log("Hide image start:" + hideImageStart);
    console.log("Hide image:" + hideImage);
    if (hideImageStart == false) {
      hideImageStart = true;
      hideImage = false;
      console.log("Displaying image for " + delay);
      setTimeout(HideImage, delay * 1000);
    }
  }

  function HideImage() {
    hideImageStart = false;
    hideImage = true;
    image = require('../../assets/NumberSense/Images/Empty.png');
  }


  function NewImage() {
    if (currQuestion.image != undefined) {
      console.log(oldQuestion);
      console.log(currQuestion);
      oldQuestion = currQuestion;
      var currImage = currQuestion.image;
      var correctAnswerName;
      //gets correct answer name for testing
      for (let i = 0; i < currQuestion.answers.length; i++) {
        if (currQuestion.answers[i].correct == true)
          correctAnswerName = currQuestion.answers[i].value;
      }
      image = require('../../assets/NumberSense/Images/' + currImage);
      //console.log(oldQuestion);
      //console.log(currentQuestion);
      //console.log(currentQuestion.time);
      if (hideImageStart == false && currQuestion.time != "") {
        //start timer thing if timer is a thing
        console.log("do delay thing");
        DelayImage(parseInt(currQuestion.time));
      }
    }
  }

  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions)
      setCurrentQuestion(newQuestion())
    }
  }, [questions]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
      comboNum = 4;
    var imageName = "combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/" + imageName)
    return (require("../../assets/NumberAndPlace/Animation/" + imageName))
  }


  return (
    <PracticeGame
      parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      getplace={() => GetPlace()}
    >
      <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
        <Body>
          <FormContent style={{ right: "100px", top: "0px", width: "200px", height: "50%" }}>
            <br></br>
            {GetListOfPositions()}
          </FormContent>
          <div>{currQuestion !== undefined ? (


            <Container>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Question
                  type="text"
                  disabled
                  value={
                    currQuestion.question !== undefined
                      ? currQuestion.question.replace("$", "?")
                      : ""
                  }
                ><Textfit mode="single" style={{ height: "80%" }} > {currQuestion.question}</Textfit></Question>
              </div>

              <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                {currQuestion.image != "" && currQuestion.questionHTML == "" ? (
                  <img src={image}></img>
                  /*<img src = {image} className ={style.geoImg} filter = {hue-rotate(60deg);}></img>*/
                ) : (
                    <div></div>
                  )}
                {currQuestion.questionHTML != "" ? (
                  <DynamicStyle>
                    <div dangerouslySetInnerHTML={{ __html: currQuestion.questionHTML }}></div>
                  </DynamicStyle>
                ) :
                  (
                    <div></div>
                  )}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                {showColouredFeedback == false && currQuestion.answers !== undefined &&
                  currQuestion.answers.map(answer => (
                    <Button
                      value={<div dangerouslySetInnerHTML={answer.value} />}
                      style={{ flex: 1, margin: "20px" }}
                      onClick={() => checkResult(answer, true)}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </Button>
                  ))}

                {showColouredFeedback == true && currQuestion.answers !== undefined &&
                  currQuestion.answers.map(answer => (
                    <Button
                      value={<div dangerouslySetInnerHTML={answer.value} />}
                      style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </Button>
                  ))}
              </div>
            </Container>


          ) : <h1>help</h1>}
          </div>
          <Combo>
            <span style={{ fontSize: "50px" }}>{combo}</span>
            <span style={{ fontSize: "20px" }}>COMBO</span>
          </Combo>
        </Body>
      </div>
    </PracticeGame>
  );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url();
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;

const Question = styled.div`
  background: #E9E9E9;
  user-select: none;
  width: 40em;
  line-height: 35px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 20px 0px 20px;
  `;

const Button = styled.div`
        text-align: center;
        width: 5em;
        line-height: 35px;
        font-size: 3em;
  padding: 35px 0px 35px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

      const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;

